
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './assets/css/style.css';
import './assets/css/fontawesome.min.css';
import './assets/css/bootstrap.min.css';
import './assets/css/datatables.min.css';
import './assets/css/jquery.dataTables.min.css';
import './assets/css/responsive.dataTables.min.css';
import './assets/css/responsive.css';
import './assets/css/style.css.map';
import './assets/js/script';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import LoginForm from './components/Auth/LoginForm';
import MasterLayout from './components/Dashbaord/MasterLayout';
import loginBg from './images/login_bg.png';
import ForgotPassword from './components/Auth/ForgotPassword';
import ResetPassword from './components/Auth/ResetPassword';
import PrivateRoute from './components/PrivateRoute';
import AdminDashboard from './components/AdminDashboard/AdminDashboard';
import UserList from './components/User/UserList';
import AddUser from './components/User/AddUser';
import Logout from './components/Auth/Logout';
import AddTicket from './components/Ticket/AddTicket';
import TicketList from './components/Ticket/TicketList';
import EditTicket from './components/Ticket/EditTicket';
import ViewTicket from './components/Ticket/ViewTicket';
import CallRecording from './components/Ticket/CallRecording';
import ArchivedTicket from './components/Ticket/ArchivedTicket';
import EditUser from './components/User/EditUser';
import CustomerInfraList from './components/CustomerInfrastructure/CustomerInfraList';
import AddCustomerInfra from './components/CustomerInfrastructure/AddCustomerInfra';

import AddCustomer from './components/Customer/AddCustomer/AddCustomer';
import CustomerList from './components/Customer/CustomerList';
import NotFound from './components/NotFound/NotFound';
import EditCustomer from './components/Customer/EditCustomer/EditCustomer';
import ReportContainer from './components/ReportsPage/ReportContainer';
import UpdatePassword from './components/Auth/UpdatePassword';
import ViewProfile from './components/Auth/ViewProfile';
import Call from './components/Twilio/Call';
import PrivacyPolicy from './components/Auth/PrivacyPolicy';
import Deleteaccount from './components/Auth/Deleteaccount';
function App() {
  const queryClient = new QueryClient();


  return (
    <div className="h-screen bg-cover bg-center" style={{ backgroundImage: `url(${loginBg})` }}>
      <QueryClientProvider client={queryClient}>
        <Router>
          <Routes>
            <Route path="/" element={<LoginForm />} />
            <Route path="/ForgotPassword" element={<ForgotPassword />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/deleteaccount" element={<Deleteaccount />} />
            <Route path="/resetPassword" element={<ResetPassword />} />

            <Route path="/logout" element={<PrivateRoute><MasterLayout><Logout /></MasterLayout></PrivateRoute>} />
            <Route path="/updatepassword" element={<PrivateRoute><MasterLayout><UpdatePassword /></MasterLayout></PrivateRoute>} />
            <Route path="/viewprofile" element={<PrivateRoute><MasterLayout><ViewProfile /></MasterLayout></PrivateRoute>} />
            <Route path="/Dashboard" element={<PrivateRoute><MasterLayout><AdminDashboard /></MasterLayout></PrivateRoute>} />
            <Route path="/customerlist" element={<PrivateRoute><MasterLayout><CustomerList /></MasterLayout></PrivateRoute>} />
            <Route path="/tickets" element={<PrivateRoute><MasterLayout><TicketList /></MasterLayout></PrivateRoute>} />
            <Route path="/tickets/addTicket" element={<PrivateRoute><MasterLayout><AddTicket /></MasterLayout></PrivateRoute>} />
            <Route path="/tickets/editTicket/:id" element={<PrivateRoute><MasterLayout><EditTicket /></MasterLayout></PrivateRoute>} />
            <Route path="/tickets/viewTicket/:id" element={<PrivateRoute><MasterLayout><ViewTicket /></MasterLayout></PrivateRoute>} />
            <Route path="/tickets/archivedTickets" element={<PrivateRoute><MasterLayout><ArchivedTicket /></MasterLayout></PrivateRoute>} />
            <Route path="/tickets/viewCallRecording/:ticketId" element={<PrivateRoute><MasterLayout><CallRecording /></MasterLayout></PrivateRoute>} />
            <Route path="/customerInfrastructure" element={<PrivateRoute><MasterLayout><CustomerInfraList /></MasterLayout></PrivateRoute>} />
            <Route path="/customerInfrastructure/add" element={<PrivateRoute><MasterLayout><AddCustomerInfra /></MasterLayout></PrivateRoute>} />
            <Route path="/customerInfrastructure/add/:c_id" element={<PrivateRoute><MasterLayout><AddCustomerInfra /></MasterLayout></PrivateRoute>} />
            <Route path="/reports" element={<PrivateRoute><MasterLayout><ReportContainer /></MasterLayout></PrivateRoute>} />
            <Route path="/userlist" element={<PrivateRoute><MasterLayout><UserList /></MasterLayout></PrivateRoute>} />
            <Route path="/UserList/adduser" element={<PrivateRoute><MasterLayout><AddUser /></MasterLayout></PrivateRoute>} />
            <Route path="/UserList/edituser/:user_uuid" element={<PrivateRoute><MasterLayout><EditUser /></MasterLayout></PrivateRoute>} />
            <Route path="/customerlist/addcustomer" element={<PrivateRoute><MasterLayout><AddCustomer /></MasterLayout></PrivateRoute>} />
            <Route path="/customerlist/edit-customer/:customer_uuid" element={<PrivateRoute><MasterLayout><EditCustomer /></MasterLayout></PrivateRoute>} />
            <Route path="/call" element={<PrivateRoute><Call /></PrivateRoute>} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </QueryClientProvider>
    </div>
  );
}

export default App;


